import { contentItemAction } from '../../../actions/contentItemActions';
import { menuAction } from '../../../actions/menuActions';
import { trackingAction } from './tracking/itemsTrackingActions';

export type CurrentItemReducerState = string | null;

export function currentItemReducer(state: CurrentItemReducerState = null, action: any): CurrentItemReducerState {
  switch (action.type) {
    case menuAction.SideMenu_SelectNonSequencedFlowItem:
    case menuAction.SideMenu_SelectedQuiz: {
      return action.payload.id;
    }
    case menuAction.SideMenu_SelectSequencedFlowItem:
      return action.payload.selectedItem.id;

    case menuAction.SideMenu_SelectedSubmenuItem: {
      if (action.payload.selectedItem.id === state) {
        return state;
      }
      return null;
    }
    case menuAction.SideMenu_DeselectItem:
    case trackingAction.Tracking_ResetProgress:
    case contentItemAction.SequencedContent_Finish_Selected:
    case contentItemAction.Quiz_QuizClosed:
    case menuAction.SideMenu_SelectedResource:
      return null;
    default:
      return state;
  }
}
